import { modifier } from 'ember-modifier';

/**
 * Handle an interactive event in a noninteractive way.
 * This may be helpful if you want to do something on mouse click or keypress on a div but you
 * don't want/need to identify the div/span as a button
 */
export default modifier(
    function nonInteractiveEvent(element, properties, { name, handler }) {
        element.addEventListener(name, handler);
    },
    { eager: false },
);
